import { render, staticRenderFns } from "./product2.vue?vue&type=template&id=0727c237&scoped=true"
import script from "./product2.vue?vue&type=script&lang=js"
export * from "./product2.vue?vue&type=script&lang=js"
import style0 from "./product2.vue?vue&type=style&index=0&id=0727c237&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727c237",
  null
  
)

export default component.exports